module.exports = __webpack_public_path__ + "media/in_house/hero-9be10c4c.jpg";